import { urls } from 'Constants/Urls'
import { AddressSuggestResult } from 'Models'
import { axiosDS } from '@pp/axios'
import { Id } from 'Types/aliases'
import { AdvertisingDataModel } from 'Src/modules'

const updateAdvertising = async (id: Id, data: AdvertisingDataModel) => {
	const res = await axiosDS().patch<AddressSuggestResult>(
		urls.user.advertising.replace(':id', id.toString()),
		{ data }
	)
	return res.data
}

export const advertApi = {
	updateAdvertising,
}
